export default {
  getBranding: (subdomain?: string) => ['brandings', subdomain],
};
